import {computed} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';

import {yaMetrica} from '@/core/plugins/yaMetrica';
import {getCurrentAnalyticsActions} from '@/core/utils/getCurrentAnalyticsActions';
import * as ANALYTICS_ACTIONS_FOR_FORM from '@/core/constants/analyticsActionsForForm';

export function useMetrica() {
    const route = useRoute();

    const currentRage = computed(() => {
        return route.value?.path?.split('/').filter(Boolean).slice(-1)[0] ?? '';
    });

    function sendStatistics() {
        try {
            yaMetrica('sendForm');

            getCurrentAnalyticsActions(currentRage.value, ANALYTICS_ACTIONS_FOR_FORM.YM_ACTIONS)
                .forEach((ymAction) => ymAction && yaMetrica(ymAction));

            getCurrentAnalyticsActions(currentRage.value, ANALYTICS_ACTIONS_FOR_FORM.TMR_ACTIONS)
                .forEach((tmrAction) => {
                    if (tmrAction && window._tmr) {
                        window._tmr.push({type: 'reachGoal', goal: tmrAction});
                    }
                });
        } catch (error) {
            console.error(error);
        }
    }

    return {
        sendStatistics,
    };
}
